import { Navigate, Outlet } from 'react-router-dom'; // Import useLocation for route tracking

import { useAuth } from '@/context/CoginitoAuthProvider';

export function AuthLayout({ children }: { children?: React.ReactNode }) {
  const { dbUser } = useAuth();

  if (dbUser) {
    return <Navigate to="/" />;
  }
  return (
    <main className="w-screen min-h-screen bg-slate-50 dark:bg-[#2A2A2A]">
      {/* <AuthNavbar /> */}

      {children ?? <Outlet />}
    </main>
  );
}
